import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css'],
})
export class AlertComponent implements OnInit, OnChanges {
  @Input() type: string;
  @Input() text: string;
  @Input() show: boolean;
  @Input() html: boolean;
  @Input() closable = true;
  isVisible = true;
  constructor() {}

  ngOnInit() {}

  close() {
    this.isVisible = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']) {
      this.isVisible = changes['show'].currentValue;
    }
  }
}
